import { Database } from '@/types/supabase';
import { supabase } from './supabase';
import { authRedirectUrl } from './constants';

export type SignUpData = {
  naam: string;
  email: string;
  password: string;
  telefoonnummer?: string;
  inviteCode?: string;
};

export async function signUp({
  email,
  password,
  naam,
  telefoonnummer,
  inviteCode,
}: SignUpData) {
  // note a postgres trigger will handle creating the public.profiles record
  //   (and team_user_link if a valid invite code was provided)
  const { data: authData, error: authError } = await supabase.auth.signUp({
    email,
    password,
    // here we can insert arbitrary metadata
    //   https://supabase.com/docs/guides/auth/managing-user-data?queryGroups=language&language=js#adding-and-retrieving-user-metadata
    options: {
      data: {
        naam,
        telefoonnummer,
        invite_code: inviteCode,
      },
    },
  });

  if (authError) throw authError;

  return authData;
}

export async function resetPassword(email: string) {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: authRedirectUrl('/reset-password'),
  });
  if (error) throw error;
  return { success: true };
}

export async function updatePassword(newPassword: string) {
  const { error } = await supabase.auth.updateUser({
    password: newPassword,
  });
  if (error) throw error;
}

export async function signIn({
  email,
  password,
}: {
  email: string;
  password: string;
}) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    console.error('Sign in error:', error);
    throw error;
  }

  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}
